import React from "react";
import { Box, Button, Container, Grid, Typography } from "@mui/material";

export default function Hero() {
  return (
    <Box
      sx={{
        bgcolor: "primary.main",
        color: "white",

        backgroundImage:
          "linear-gradient(rgba(0, 61, 77, 0.9), rgba(0, 61, 77, 0.9))",
        position: "relative",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          {/* Kolom Kiri: Konten Teks */}
          <Grid item xs={12} md={6}>
            <Box>
              <Typography
                variant="h2"
                sx={{
                  color: "white",
                  maxWidth: "800px",
                }}
              >
                Berbagi Pakai Data, Membangun Negeri.
              </Typography>
              <Typography
                variant="h5"
                sx={{ mt: 3, mb: 6, maxWidth: "800px", opacity: 0.9 }}
              >
                Platform terintegrasi untuk mengumpulkan, menyajikan, dan
                menyebarluaskan data dan informasi geospasial
              </Typography>
              <Typography
                component="span"
                sx={{
                  bgcolor: "secondary.main",
                  color: "white",
                  px: 2,
                  py: 1,
                  borderRadius: 1,
                  display: "inline-block",
                  mb: 4,
                }}
              >
                Gratis dan Sumber Terbuka
              </Typography>
            </Box>
          </Grid>

          {/* Kolom Kanan: Gambar */}
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src={
                process.env.PUBLIC_URL + "/static/images/geoportal-palapa.webp"
              } // Ganti dengan jalur gambar Anda
              alt="Logo BIG"
              sx={{
                width: "100%",
                maxWidth: "1200px", // Batas lebar maksimum
                //height: "auto",
                mx: "auto", // Center jika kolom kecil
                display: "block",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
